// extracted by mini-css-extract-plugin
export default {"description":"RecommendUs_description__nbqG3"};